export interface PageActivity {
  isActive(): boolean
  subscribe(listener: () => void): () => void
}

/** Reports when the browser regains network connectivity. */
export interface NetworkActivity {
  subscribeToRecovery(listener: () => void): () => void
}

const documentNetworkActivity: NetworkActivity = {
  subscribeToRecovery: listener => {
    if (typeof window === 'undefined') return () => {}
    window.addEventListener('online', listener)
    return () => window.removeEventListener('online', listener)
  },
}

export function getDocumentNetworkActivity(): NetworkActivity {
  return documentNetworkActivity
}

let documentPageActivity: PageActivity | undefined

export function getDocumentPageActivity(): PageActivity {
  if (documentPageActivity) return documentPageActivity

  const listeners = new Set<() => void>()
  const notify = () => {
    for (const listener of listeners) listener()
  }
  documentPageActivity = {
    isActive: () => typeof document === 'undefined' || document.visibilityState !== 'hidden',
    subscribe: listener => {
      if (listeners.size === 0 && typeof document !== 'undefined') {
        document.addEventListener('visibilitychange', notify)
        window.addEventListener('pageshow', notify)
      }
      listeners.add(listener)
      return () => {
        listeners.delete(listener)
        if (listeners.size === 0 && typeof document !== 'undefined') {
          document.removeEventListener('visibilitychange', notify)
          window.removeEventListener('pageshow', notify)
        }
      }
    },
  }
  return documentPageActivity
}
